import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video", "overlay"];

  declare overlayTarget: HTMLElement;
  declare videoTarget: HTMLElement;

  show() {
    this.overlayTarget.removeAttribute("inert");
    this.overlayTarget.classList.add("d-flex");
    this.overlayTarget.dataset.visible = "true";
  }

  async play() {
    try {
      const video = this.videoTarget.querySelector("video") as HTMLVideoElement;
      await video.play();
      this.hideOverlay();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Something went wrong", error);
    }
  }

  hideOverlay() {
    this.overlayTarget.setAttribute("inert", "true");
    this.overlayTarget.classList.remove("d-flex");
    this.overlayTarget.dataset.visible = "false";
  }
}
